
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dispensaries",
      function () {
        return require("private-next-pages/dispensaries/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dispensaries"])
      });
    }
  